import { useCallback } from 'react'
import type { VisibilityState, OnChangeFn } from '@tanstack/react-table'
import { useLocalStorage } from './useLocalStorage'

export function useColumnVisibility(storageKey: string, defaultVisibility: VisibilityState = {}) {
  const [columnVisibility, setStored] = useLocalStorage<VisibilityState>(
    `columnVisibility:${storageKey}`,
    defaultVisibility
  )

  const setColumnVisibility: OnChangeFn<VisibilityState> = useCallback(
    (updaterOrValue) => {
      setStored((prev) => (typeof updaterOrValue === 'function' ? updaterOrValue(prev) : updaterOrValue))
    },
    [setStored]
  )

  return { columnVisibility, setColumnVisibility }
}
